import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import {
  RolloverPropertyTransferredSharesClassOptions,
} from '../../../../../../../../../../../common/src/options/calculations/rollover/rollover-property-transferred-shares-class.options';
import {
  RolloverPropertyTransferredOptions,
} from '../../../../../../../../../../../common/src/options/calculations/rollover/rollover-property-transferred.options';
import {
  WarningArrayItemDeletionComponent,
} from '../../../../warning-array-item-deletion/warning-array-item-deletion.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import {
  RolloverSharesClassOptions,
} from '../../../../../../../../../../../common/src/options/calculations/rollover/rollover-shares-class.options';
import {
  RolloverOptions,
} from '../../../../../../../../../../../common/src/options/calculations/rollover/rollover.options';
import {AdvancedFormGroup} from "@magieno/angular-advanced-forms";
import { AdvancedFormControl } from "@magieno/angular-advanced-forms";
import {AdvancedFormArray} from "@magieno/angular-advanced-forms";
import { AdvancedForm } from "@magieno/angular-advanced-forms";
import { Locale } from '@magieno/common';
import { CurrencyEnum } from '@magieno/common';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-rollover-property-share-classes-form',
  templateUrl: './rollover-property-share-classes-form.component.html',
  styleUrls: ['./rollover-property-share-classes-form.component.scss'],
  standalone: false,
})
export class RolloverPropertyShareClassesFormComponent implements OnInit, OnDestroy {

  onIsCalculateNumberOfPreferredSharesChangeSubscription: Subscription;


  @Input()
  propertyForm: AdvancedFormGroup<RolloverPropertyTransferredOptions>;

  @Input()
  form: AdvancedForm<RolloverOptions>;

  @Input()
  propertyTransferredIndex: number;

  shareClassesSubscription: Subscription;

  shareClassesKeyValues: { key: string, value: string }[] = [];


  constructor(public modalService: NgbModal, private readonly translateService: TranslateService) {

  }

  get currency(): CurrencyEnum {
    return CurrencyEnum.CAD;
  }

  get locale(): Locale {
    switch (this.translateService.currentLang) {
      case 'fr':
        return Locale.fr_CA;
      case 'en':
        return Locale.en_CA;
    }

    return Locale.fr_CA;
  }

  get isCalculateNumberOfPreferredShares(): AdvancedFormControl<boolean, boolean, boolean> {
    return this.propertyForm.formElements.isCalculateNumberOfPreferredShares as AdvancedFormControl<boolean, boolean, boolean>;
  }

  get propertyTransferredSharesClasses(): AdvancedFormArray<RolloverPropertyTransferredSharesClassOptions> {
    return this.propertyForm.formElements.sharesClasses as AdvancedFormArray<RolloverPropertyTransferredSharesClassOptions>;
  }

  get firstSharesClassId(): AdvancedFormControl<string, string, string> {
    return this.propertyTransferredSharesClasses.formGroups[0].formElements.sharesClassId as AdvancedFormControl<string, string, string>;
  }

  ngOnInit(): void {
    this.onIsCalculateNumberOfPreferredSharesChangeSubscription = (this.propertyForm.formElements.isCalculateNumberOfPreferredShares as AdvancedFormControl<boolean, boolean, boolean>).value$.subscribe((value) => {
      this.resetArray();
    });

    this.mapShareClasses(this.form.formElements.sharesClasses.value);

    this.shareClassesSubscription = this.form.formElements.sharesClasses.value$.subscribe(value => {
      this.mapShareClasses(value.value);
    });
  }

  ngOnDestroy() {
    this.onIsCalculateNumberOfPreferredSharesChangeSubscription?.unsubscribe();
    this.shareClassesSubscription?.unsubscribe();
  }

  mapShareClasses(shareClasses) {
    this.shareClassesKeyValues = shareClasses.map((shareClass) => {
      return {
        key: shareClass.title,
        value: shareClass.id,
      };
    });
  }

  getShareClassesSelectKeyValues(): { key: string, value: string }[] {
    return this.shareClassesKeyValues;
  }

  addPropertyTransferredSharesClass() {
    return (this.propertyForm.formElements.sharesClasses as AdvancedFormArray<RolloverSharesClassOptions>).appendNew();
  }

  shouldShowFairMarketValueWarning(index: number, propertyTransferredSharesClass: AdvancedFormGroup<RolloverPropertyTransferredSharesClassOptions>) {
    if (!propertyTransferredSharesClass.value.sharesClassId) {
      return false;
    }
    const shareClass = this.getShareClassForIdSelectedByIndex(index);

    return shareClass.value.isRightToParticipate === false && shareClass.value.redemptionValue && propertyTransferredSharesClass.value.numberOfShares && (propertyTransferredSharesClass.value.numberOfShares * shareClass.value.redemptionValue !== propertyTransferredSharesClass.value.fairMarketValue);
  }


  async removePropertyTransferredSharesClass(propertyTransferredSharesClassIndexToRemove: number) {
    const modal = this.modalService.open(WarningArrayItemDeletionComponent);
    (modal.componentInstance as WarningArrayItemDeletionComponent).objectDefinition = 'cette catégorie d\'actions';
    modal.closed.subscribe(async result => {
      if (result === true) {
        this.propertyTransferredSharesClasses.delete(propertyTransferredSharesClassIndexToRemove);
        return;
      }
    });

    return;
  }

  // // handleIsCalculateNumberOfPreferredSharesVisibility(){
  // //     if(this.propertyForm.formElements.isCalculateNumberOfPreferredShares.getModel() === true){
  // //         this.enableAreShares();
  // //     } else{
  // //         this.disableAreShares();
  // //     }
  // // }
  //
  resetArray() {
    this.propertyTransferredSharesClasses.clear();
    this.propertyTransferredSharesClasses.appendNew();
  }

  getShareClass(shareClassId: string): AdvancedFormGroup<RolloverSharesClassOptions> {
    const classes = this.form.formElements.sharesClasses as AdvancedFormArray<RolloverSharesClassOptions>;
    return classes.formGroups.find((classForm) => classForm.formElements.id.value === shareClassId);
  }

  getShareClassForIdSelectedByIndex(index: number): AdvancedFormGroup<RolloverSharesClassOptions> {
    const propertyTransferredShareClass = this.propertyTransferredSharesClasses.formGroups[index] as AdvancedFormGroup<RolloverPropertyTransferredSharesClassOptions>;
    if (propertyTransferredShareClass === undefined) {
      throw new Error('Index of propertyTransferredSharesClasses does not exist');
    }
    return this.getShareClass(propertyTransferredShareClass.formElements.sharesClassId.value);
  }

  isWarning(index: number) {
    return this.getShareClassForIdSelectedByIndex(index)?.formElements?.isRightToResidual?.value === false;
  }
}
